export * from './hexadecimal-validator';


// WEBPACK FOOTER //
// ./src/app/base/base-fields/validators/index.ts